import _ from 'underscore'
import React, { useCallback, useMemo } from 'react'
import styled from 'styled-components'

import CheckboxList from 'components/CheckboxList'

import Brand from 'helpers/brand'

import { color } from 'styles/colors'

import { CustomerBase } from 'types/Customer'

type Props = {
  letter: string
  customers: Pick<CustomerBase, 'id' | 'firstName' | 'lastName' | 'companyName'>[]
  selectedIds: number[]
  onSelectedIdsChange: (customerIds: number[]) => void
  customerSearch?: string | null
  customerSearchRegex?: string | null
}

const CustomerGroup = ({
  letter,
  customers,
  selectedIds,
  onSelectedIdsChange,
  customerSearch = null,
  customerSearchRegex = null
}: Props) => {
  const customerLabel = useCallback(({ firstName, lastName, companyName }) => {
    const firstAndLastName = `${firstName || ''} ${lastName || ''}`.trim()

    const finalizedName = Brand.isResidential() ? firstAndLastName : companyName || firstAndLastName
    let label = finalizedName.length > 0 ? finalizedName : '[unknown name]'

    if (customerSearch && customerSearchRegex) {
      label = label.replace(new RegExp(customerSearchRegex, 'gi'), str => `<span>${str}:-*/</span>`)
    }

    return label
  }, [customerSearch, customerSearchRegex])

  const customerLabelsAndIds = useMemo(() => _.map(customers, ({ firstName, lastName, companyName, id }) => {
    return { label: customerLabel({ firstName, lastName, companyName }), id }
  }), [customers, customerLabel])

  return (
    <>
      <S.DirectoryIndex>{letter}</S.DirectoryIndex>

      <CheckboxList
        {...{ selectedIds, onSelectedIdsChange }}
        items={customerLabelsAndIds}
      />
    </>
  )
}

export default CustomerGroup

const S = {
  DirectoryIndex: styled.div`
    color: ${color('customerDirectoryIndex')};
    font-weight: 600;

    &:not(:first-child) {
      margin-top: 10px;
    }
  `
}
